import PluginPost from './PluginPost'

export default PluginPost
